import { useEffect, useState } from 'react'

export const useElementHeight = (elementRef: React.RefObject<HTMLElement>) => {
  const currentElementRef = elementRef.current

  const [height, setHeight] = useState(currentElementRef ? getElementHeight(currentElementRef) : 0)

  useEffect(() => {
    if (!currentElementRef) return

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const target = entry.target as HTMLElement
        const height = getElementHeight(target)
        setHeight(height)
      }
    })

    resizeObserver.observe(currentElementRef)

    return () => {
      resizeObserver.disconnect()
    }
  }, [currentElementRef])

  return height
}

const getElementHeight = (element: HTMLElement) => {
  return Math.max(element.scrollHeight, element.offsetHeight, element.clientHeight, parseInt(element.style.height))
}
